/*
 * Module for the Service Purhase Setup View
*/

rs.module("content/participant/member/servicepurchase/setup",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, codeValues) {

            // Unpack jsSelectors
            var form = $.js(jsSelectors.form);

            // Add event to hide purchase types section when one of these fields changes
            form.js(jsSelectors.planSelect).change(hideAndClearPurchaseTypesSection);
            form.js(jsSelectors.employerSelect).change(hideAndClearPurchaseTypesSection);
            form.js(jsSelectors.offerDate).change(hideAndClearPurchaseTypesSection);

            // Load employers for selected plan 
            form.js(jsSelectors.planSelect).change(function () {

                selectHelper.getHelper(form.js(jsSelectors.employerSelect)).loadOptionsFrom(
                    backendUrls.loadEmployers,
                    {
                        planKey: $(this).val()
                    });
            });

            // Load purchase types 
            form.js(jsSelectors.loadPurchaseTypesButton).click(function () {

                // Validate the form
                var validator = form.validate();
                var isValid = validator.form();

                // Only send lookup parameters if form is valid
                if (isValid) {

                    form.js(jsSelectors.loadingSpinner).show();
                    form.js(jsSelectors.effectiveDate).val(form.js(jsSelectors.offerDate).val());

                    selectHelper.getHelper(form.js(jsSelectors.purchaseTypeSelect)).loadOptionsFrom(
                        backendUrls.loadPurchaseTypes,
                        {
                            offerDate: form.js(jsSelectors.offerDate).val()
                        },
                        {
                            withBlank: true
                        },
                        function () {
                            form.js(jsSelectors.loadingSpinner).hide();
                            form.js(jsSelectors.purchaseTypesSection).show();
                            form.js(jsSelectors.saveButton).setDisabled(false).show();
                            form.js(jsSelectors.loadPurchaseTypesButton).hide();
                        });
                }             
            });

            // Load purchase type details when purchase type is changed
            form.js(jsSelectors.purchaseTypeSelect).change(function () {

                if ($(this).val() != "") {

                    form.js(jsSelectors.noPurchaseTypeMessage).hide();
                    form.js(jsSelectors.detailTable).show();

                    $.get(
                        backendUrls.getPurchaseTypeDetail,
                        {
                            offerDate: form.js(jsSelectors.offerDate).val(),
                            spcMasterRuleKey: $(this).val()
                        }

                    ).done(function (results) {

                        // If contract type is non service purchase, disable service amount field and clear errors
                        var disableServiceAmount = results.contractType.key == codeValues.nonServicePurchase || 
                            (results.spcCostMethod.key == codeValues.contributionBased);

                        form.js(jsSelectors.serviceAmount).prop("disabled", disableServiceAmount);
                        if (disableServiceAmount) {
                            form.js(jsSelectors.serviceAmount).val(null).clearErrors();
                            form.js(jsSelectors.serviceAmountHidden).val(0);
                        }

                        // If cost method is manual, enable lump sum cost field and clear errors
                        form.js(jsSelectors.lumpSumCost).prop("disabled", results.spcCostMethod.key != codeValues.manual);
                        if (results.spcCostMethod.key != codeValues.manual) {
                            form.js(jsSelectors.lumpSumCost).val(null).clearErrors();
                            form.js(jsSelectors.lumpSumCostHidden).val(0);
                        }

                        // Set hidden field values so they can be persisted on submit
                        form.js(jsSelectors.contractTypeHiddenField).val(results.contractType.key);
                        form.js(jsSelectors.serviceAllocationHiddenField).val(results.serviceAllocationMethod.key);

                        if (results.serviceCreditType != null) {
                            form.js(jsSelectors.serviceTypeHiddenField).val(results.serviceCreditType.key);
                            form.js(jsSelectors.serviceType).html(results.serviceCreditType.name);
                        }
                        else {
                            form.js(jsSelectors.serviceTypeHiddenField).val(null);
                            form.js(jsSelectors.serviceType).html("");
                        }

                        // Load purchase type details for popup
                        form.js(jsSelectors.contractType).html(results.contractType.name);
                        form.js(jsSelectors.allocationMethod).html(results.serviceAllocationMethod.name);
                        form.js(jsSelectors.payableByPayroll).html(results.payrollDeductionFl ? "Yes" : "No");
                    });
                }
                else {
                    form.js(jsSelectors.noPurchaseTypeMessage).show();
                    form.js(jsSelectors.detailTable).hide();
                }
            });

            // Show/hide purchase type detail on hover
            form.js(jsSelectors.purchaseTypeDetail).hoverIntent({
                handlerOver: function (event) {
                    form.js(jsSelectors.purchaseTypeDetailPopup).show();
                },
                handlerOut: function (event) {
                    form.js(jsSelectors.purchaseTypeDetailPopup).hide();
                },
                hoverOutDelay: 400
            });

            //
            // Hide the purchase types section and clear its fields
            //
            function hideAndClearPurchaseTypesSection() {

                form.js(jsSelectors.purchaseTypesSection).hide();
                form.js(jsSelectors.saveButton).setDisabled().hide();
                form.js(jsSelectors.loadPurchaseTypesButton).show();

                form.js(jsSelectors.purchaseTypeSelect).clearErrors();
                form.js(jsSelectors.effectiveDate).val(null).clearErrors();
                form.js(jsSelectors.serviceAmount).val(null).clearErrors();
                form.js(jsSelectors.lumpSumCost).val(null).clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);